export const osnCheckIcon = {
  // eslint-disable-next-line max-len
  data: `<svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.50195 14.4775L7.92374 18.7752C8.36379 19.2029 9.06724 19.1929 9.49493 18.7528C9.50118 18.7464 9.50736 18.7399 9.51345 18.7333L20.6448 6.71143" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'check',
};
